var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 17.3C11.2995 17.3 10.5995 17.03 10.0695 16.5L3.54953 9.98C3.25953 9.69 3.25953 9.21 3.54953 8.92C3.83953 8.63 4.31953 8.63 4.60953 8.92L11.1295 15.44C11.6095 15.92 12.3895 15.92 12.8695 15.44L19.3895 8.92C19.6795 8.63 20.1595 8.63 20.4495 8.92C20.7395 9.21 20.7395 9.69 20.4495 9.98L13.9295 16.5C13.3995 17.03 12.6995 17.3 11.9995 17.3Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f5df78b6e318f14f015499b6cf4cabdf.svg";
export { ForwardRef as ReactComponent };